(async function () {
  'use strict';
  if (!window.SpinweldCart || !document.querySelector('[data-spinweld-group]')) return;
  const root = window.Shopify?.routes?.root || '/';
  async function request(path, body) {
    const response = await fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Cart update failed. Please try again.');
    return data;
  }
  const client = SpinweldCart.createClient({ request, storage: sessionStorage });
  const status = document.createElement('p'); status.setAttribute('role', 'status');
  document.querySelector('[data-spinweld-group]').closest('table').before(status);
  let busy = false;
  let blocked = false;
  // Warehouse replaces the cart section after ordinary item updates. Reboot
  // group controls and validation instead of leaving detached event handlers.
  document.addEventListener('cart:rerendered', () => { blocked = true; location.reload(); });
  function blockCheckout(message) {
    blocked = true; status.textContent = message;
    document.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = true; });
  }
  document.addEventListener('submit', event => { if (busy || blocked) { event.preventDefault(); status.textContent = 'Resolve the tank cart update before checkout.'; } }, true);
  try {
    const cart = await request('cart.js');
    const invalid = SpinweldCart.invalidGroups(cart);
    if (invalid.length) {
      blockCheckout('A tank build is incomplete. Remove that tank group and reopen its drawing before checkout.');
      invalid.forEach((group, index) => {
        const removeIncomplete = document.createElement('button');
        removeIncomplete.type = 'button'; removeIncomplete.className = 'button button--secondary';
        removeIncomplete.textContent = `Remove incomplete tank build ${index + 1}`;
        status.after(removeIncomplete);
        removeIncomplete.addEventListener('click', async () => {
          if (busy || !confirm('Remove this incomplete build and its remaining fittings and installation charges?')) return;
          busy = true; removeIncomplete.disabled = true;
          try {
            const current = await request('cart.js');
            const removed = await request('cart/update.js', {updates: Object.fromEntries(SpinweldCart.groupItems(current,group).map(item=>[item.key,0]))});
            if (SpinweldCart.groupItems(removed,group).length) throw new Error('Some items remain. Please retry removing this incomplete build.');
            await client.synchronizeNote(removed); location.reload();
          } catch(error) { status.textContent=error.message; busy=false; removeIncomplete.disabled=false; }
        });
      });
    }
    const pending = JSON.parse(sessionStorage.getItem('ervp.spinweld.cart.pending.v1') || 'null');
    if (pending) {
      blockCheckout('A previous tank update needs to be resolved before checkout. Your original tank has been kept until the replacement is complete.');
      const recover = document.createElement('button'); recover.type = 'button'; recover.className = 'button button--secondary'; recover.textContent = SpinweldCart.matches(cart,pending.group,pending.items) ? 'Finish tank update' : 'Remove incomplete update';
      status.after(recover);
      recover.addEventListener('click', async () => {
        recover.disabled = true;
        try {
          const current = await request('cart.js');
          if (SpinweldCart.matches(current,pending.group,pending.items)) await client.commit(pending.items,pending.group,pending.replaceGroup);
          else {
            const removed = await request('cart/update.js',{updates:Object.fromEntries(SpinweldCart.groupItems(current,pending.group).map(item=>[item.key,0]))});
            if (SpinweldCart.groupItems(removed,pending.group).length) throw new Error('Incomplete items could not be removed. Please retry.');
            await client.synchronizeNote(removed); sessionStorage.removeItem('ervp.spinweld.cart.pending.v1');
          }
          location.reload();
        } catch (error) { status.textContent=error.message; recover.disabled=false; }
      });
    }
    document.querySelectorAll('[data-spinweld-group]').forEach(row => {
      const group = row.dataset.spinweldGroup;
      row.querySelectorAll('.quantity-selector, .line-item__quantity-remove').forEach(el => { el.hidden = true; el.style.display = 'none'; });
      if (row.dataset.spinweldRole !== 'tank') return;
      const tank = cart.items.find(item => SpinweldCart.groupOf(item) === group && item.properties['_Spinweld Component'] === 'tank');
      if (!tank) return;
      const controls = document.createElement('div'); controls.style.cssText = 'display:flex;flex-wrap:wrap;gap:12px;align-items:center;margin-top:12px';
      const edit = document.createElement('a'); edit.textContent = 'Edit tank & fittings'; edit.className = 'link';
      edit.href = root + 'pages/custom-rv-tank-builder?job=' + encodeURIComponent(group) + '&edit_group=' + encodeURIComponent(group);
      const label = document.createElement('label'); label.textContent = 'Identical tanks ';
      const qty = document.createElement('input'); qty.type = 'number'; qty.min = '1'; qty.max = '20'; qty.step = '1'; qty.value = String(tank.quantity); qty.style.cssText = 'width:64px;padding:8px;border:1px solid #ccc;font-size:16px'; label.append(qty);
      const update = document.createElement('button'); update.type = 'button'; update.textContent = 'Update quantity'; update.className = 'button button--secondary';
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove tank & fittings'; remove.className = 'link';
      async function change(quantity) {
        if (busy) return; busy = true; update.disabled = remove.disabled = true;
        try {
          const latest = await request('cart.js');
          const updates = quantity === 0 ? Object.fromEntries(SpinweldCart.groupItems(latest, group).map(item => [item.key, 0])) : SpinweldCart.quantityUpdates(latest, group, quantity);
          const changed = await request('cart/update.js', { updates });
          if (!SpinweldCart.quantityMatches(latest, changed, group, quantity)) {
            blockCheckout('The complete tank group could not be updated. Reload the cart to review and recover the build before checkout.');
            throw new Error('The complete tank group could not be updated. Reload the cart to review and recover the build before checkout.');
          }
          await client.synchronizeNote(changed);
          location.reload();
        } catch (error) { status.textContent = error.message; busy = false; update.disabled = remove.disabled = false; }
      }
      update.addEventListener('click', () => change(Number(qty.value)));
      remove.addEventListener('click', () => { if (confirm('Remove this tank and all its fittings and installation charges?')) change(0); });
      controls.append(edit, label, update, remove); row.querySelector('.line-item__meta').append(controls);
    });
  } catch (error) { blockCheckout('Tank cart verification is unavailable: ' + error.message); }
})();
